import { extendObservable, runInAction } from 'mobx';

import { ShippingOptionsController } from '../networking/controllers/ShippingOptionsController';
import { Logger } from '../helpers/Logger';

class ShippingStoreClass {
  constructor() {
    extendObservable(this, {
      isLoadingShippingOptions: false,
      shippingOptions: null,
    });
  }

  async fetchShippingOptions(cart, address, nextDate) {
    runInAction(() => {
      this.isLoadingShippingOptions = true;
      this.shippingOptions = null;
    });
    const addressId = address.id;
    const serializedCart = cart.map(item => ({
      amount: item.amount,
      productId: item.product.id,
    }));
    try {
      const shippingOptions = await
      ShippingOptionsController.all(addressId, serializedCart, nextDate, `${address.cityName.id}-${address.department.id}`);
      runInAction(() => {
        this.shippingOptions = shippingOptions;
      });
    } catch (error) {
      Logger.warn(error);
    } finally {
      runInAction(() => {
        this.isLoadingShippingOptions = false;
      });
    }
  }
}

const ShippingStore = new ShippingStoreClass();

export { ShippingStore };



// WEBPACK FOOTER //
// ./src/stores/ShippingStore.js